export const SITE_TYPE = "SHOPIFY";

export const SHOPIFY_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/account/login" },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/account/register" },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/account" },
  CART: { target: `${SITE_TYPE}:CART`, url: "/cart" },
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/account/login",
  },
  // 약관을 포함한 나머지 페이지들 경로가 사용자가 정의하기 때문에 특정 안됨
  // 결제 페이지는 사용하는 PG사에 따라 페이지 경로가 달라져서 특정 안됨
} as const;
